import React from 'react'
import { Background, Header } from '@/components'
import HelpButton from './HelpButton'
import { FlagButton } from './FlagButton'

function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <div>
        <Header />
        <Background>
            <div className="max-w-7xl mx-auto my-auto w-full h-full py-20 px-4 md:px-0">
                {children}
            </div>
            <div className="flex gap-2 justify-end fixed top-4 right-4 md:bottom-4 md:left-4 md:top-auto md:right-auto z-50">
                <FlagButton />
                <HelpButton />
            </div>
        </Background>
    </div>
  )
}

export default MainLayout